import Menu from '../Menu';
import { helpMenuConfig } from './config';

const HELP_MENU_DISPLAY_NAME = '?';

/**
 * HelpMenu Component
 *
 * A specialized menu component for help and support options.
 * Uses the generic Menu component with help-specific configuration.
 */
const HelpMenu: React.FC = () => {
  return <Menu menuDisplayName={HELP_MENU_DISPLAY_NAME} items={helpMenuConfig} id="help-menu" />;
};

export default HelpMenu;
